import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import AveragePopOver from './AveragePopOver';
import StudentAveragePopOver from './StudentAveragePopOver';

const { array, bool, shape, string } = PropTypes;

/**
 * Draws resources table items
 * */
const ResourcesItems = ({
  isStudent,
  studentContext,
  columns,
  items,
  scoreDisplay,
  reviewModeFlag,
}) => {
  const relevantItems = items.filter((item) => item.partsWithValues !== 0);

  const partialScoreDisplay =
    reviewModeFlag && scoreDisplay === 'partial' && isStudent;

  return (
    <TableBody data-test-table-body>
      {relevantItems.map((row, index) => {
        const className = index % 2 ? 'even' : 'odd';
        return (
          <TableRow className={className} key={`resource-item-key-${index}`}>
            {columns.map((column, columnIndex) => {
              const itemColumn = row[column.value] || {};
              const {
                label,
                className: rowClassName,
                users: rawUsers,
                questions,
                resultsPathname,
              } = itemColumn;
              const users = sortBy(rawUsers, ['lastName', 'firstName']);
              let cellElement;
              let otherClassName = '';

              if (
                rowClassName &&
                rowClassName.split(' ').includes('AverageRow') &&
                label
              ) {
                const [actualPoints, totalPoints] = label.split('/');
                let averagePopOverLabel = label;

                cellElement = isStudent ? (
                  <StudentAveragePopOver
                    studentContext={studentContext}
                    label={label}
                    users={users}
                    questions={questions}
                    resultsPathname={resultsPathname}
                    partialScoreDisplay={partialScoreDisplay}
                  />
                ) : (
                  <AveragePopOver
                    label={averagePopOverLabel}
                    actualPoints={actualPoints}
                    totalPoints={totalPoints}
                    users={users}
                    questions={questions}
                    resultsPathname={resultsPathname}
                  />
                );
              } else {
                cellElement = label;
                /*
                 * were going to show 'na' in the desktop table cells when
                 * a Topic and Skill is not covered by a particular part
                 */
                if (!label) {
                  otherClassName = 'other-part-cell';
                  cellElement = <span>na</span>;
                }
              }

              return (
                <TableCell
                  className={`${rowClassName} ${otherClassName}`}
                  key={`resource-item-column-key-${index}${columnIndex}`}
                  {...(column.label === 'Topics'
                    ? {
                        scope: 'row',
                        component: 'th',
                        role: undefined,
                      }
                    : {})}
                >
                  {cellElement}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

ResourcesItems.displayName = 'ResourcesItems';

ResourcesItems.propTypes = {
  /**
   * Columns
   * */
  columns: array.isRequired,
  /**
   * Array of items for table body
   * */
  items: array.isRequired,
  /**
   * Bool
   * */
  isStudent: bool.isRequired,
  /**
   * Student context
   * */
  studentContext: shape({
    hasContext: bool,
    studentId: string,
  }),
};

ResourcesItems.defaultProps = {
  studentContext: {
    hasContext: false,
    studentId: null,
  },
};

export default ResourcesItems;
